define.alias("shared/components/shared/sourceless-trial/confirmation-modal", "media/components/shared/sourceless-trial/confirmation-modal");